import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr,load} from '../utils.js'
import UniTable from '../cmp/UniTable.js'

function RepObjHistory({data=undefined,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    let table=undefined
    if(wndData) table=wndData.table
    const setWndData=actions.setWndData
    const context=useContext(dataContext)
    const getData=context.getData
    const msg=context.msg
    let catData
    if(wndData&&wndData.object) catData=context.data[wndData.object.type]

    const cols=[
        {caption:'icon',minWidth:'24',dataId:'run',sortable:false},
        {caption:localestr('Дата'),minWidth:'75',dataId:'date',sortable:true},
        {caption:localestr('Дія'),minWidth:'50',dataId:'action',sortable:true},
        {caption:localestr('Автор'),minWidth:'75',dataId:'author',sortable:true}
    ]

    const loadData=(d)=>{
        if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            setWndData({...wndData,table:d.data})
        } else {
            load('action=repObjHistory&data='+JSON.stringify({id:wndData.object.id,type:wndData.object.type}),(dt)=>{loadData(dt)})
        }

    }

    const listFromData=(currentCol,setCurrCol)=>{
        const acts={add:localestr('Створення'),mod:localestr('Зміна даних'),rem:localestr('Позначка на знищення'),rm1:localestr('Позначка на знищення'),rm0:localestr('Відміна позначки'),set:localestr('Зміна періодичних даних'),del:localestr('Видалення періодичних даних'),rgo:localestr('Зміна періодичних даних'),pst:localestr('Проведення'),ups:localestr('Відміна проведення'),clr:localestr('Остаточне видалення'),pr1:localestr('Друк замовлення'),pr2:localestr('Друк рахунку'),pr3:localestr('Друк чека'),brk:localestr('Розділення чека')}
        let list=[]
        if (table) list=table.map((item,idx)=>{
            const newItem={uid:idx+1,date:item.date,author:{id:item.user_id,name:item.user},action:acts[item.action]}
            //const newItem={...item}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol({...newItem})
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col==='date') {
                vala=(a[col])
                valb=(b[col])
            } else if(col==='sum') {
                vala=parseFloat(a[col]||0)
                valb=parseFloat(b[col]||0)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }
    
    const setCol=(currentCol)=>{
        setWndData({...wndData,currentCol})
    }

    const tick=()=>{
        //wndData=actions.getWndData()
        //if (wndData.showRange) return
        loadData()
    }

    useEffect(() => {
        //console.log('effect1')
        if (typeof table === 'undefined') loadData()
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('date','asc',undefined)
    // eslint-disable-next-line 
    },[table])

    useEffect(() => {
        //console.log('effect2')
        const intervalHandle=setInterval(tick,30000)
        return () => clearInterval(intervalHandle)
    // eslint-disable-next-line 
    },[])

    useEffect(() => {
        if (typeof catData === 'undefined' && wndData.object.type.substring(0,3)!=='doc') getData(wndData.object.type)
    // eslint-disable-next-line 
    },[catData])


    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting

    return(
    <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={wndData.filter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={()=>{}} keyHandle={()=>{}}/>
    )
}
export default RepObjHistory